import { render, staticRenderFns } from "./Goodslist.vue?vue&type=template&id=19599f40&scoped=true&"
import script from "./Goodslist.vue?vue&type=script&lang=js&"
export * from "./Goodslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19599f40",
  null
  
)

export default component.exports